var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0165 13.9087C26.0165 6.87729 20.3165 1.17725 13.2851 1.17725C6.25375 1.17725 0.553711 6.87729 0.553711 13.9087C0.553711 20.94 6.25375 26.6401 13.2851 26.6401C20.3165 26.6401 26.0165 20.94 26.0165 13.9087Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0479 10.7133H7.38574V19.2725H10.0479V10.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.70325 9.59603C9.57488 9.59603 10.2776 8.88949 10.2776 8.01472C10.2776 7.13995 9.57488 6.43341 8.70325 6.43341C7.83162 6.43341 7.12891 7.13995 7.12891 8.01472C7.12891 8.88949 7.83162 9.59603 8.70325 9.59603Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.2982 14.7844C14.2982 13.5799 14.8523 12.8666 15.9199 12.8666C16.8996 12.8666 17.3658 13.553 17.3658 14.7844V19.2794H20.0145V13.8558C20.0145 11.5612 18.7104 10.4509 16.8861 10.4509C15.0617 10.4509 14.2982 11.864 14.2982 11.864V10.7134H11.7441V19.2726H14.2982V14.7777V14.7844Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group 17.133e3e3101c7febe8c8bee3c1d3be593.svg";
export { ForwardRef as ReactComponent };